module.exports = __webpack_public_path__ + "img/004-logo.ee199847.png";